module.exports = __webpack_public_path__ + "2f5966cf6981fa9ec5080b624835cb01.pdf";